<template>
  <!-- 
    画面: 割引プラン一覧
    用途: オペレータが割引プラン一覧を参照する
   -->
  <div>
    <CRow>
      <CCol lg="12">

        <!-- #region 割引プラン一覧 -->
        <CCard>
          <CCardHeader>
            <h3 class="card-title">割引プラン一覧</h3>
          </CCardHeader>
          <CCardBody class="px-5">
            <DiscountPlanListTable />
          </CCardBody>
          <CCardFooter class="px-5"> </CCardFooter>
        </CCard>
        <!-- #endregion 割引プラン一覧 -->

      </CCol>
    </CRow>
  </div>
</template>

<script>
import DiscountPlanListTable from "./components/DiscountPlanListTable.vue";

export default {
  name: "DiscountList",

  components: {
    DiscountPlanListTable,
  },

  data() {
    return {
    };
  },

  created() {
  },

  methods: {},
  
};
</script>

<style lang="scss">
.nav-tabs {
  margin-bottom: -1px;
  .nav-link {
    border: 1px solid #cccccc;
    color: #4b5e80;
    &.active {
      background: #cccccc;
      border: 1px solid #cccccc;
      color: #454579;
      font-weight: bold;
    }
  }
}
</style>
